(() => {
  function enhancePages() {
    document.querySelectorAll('[data-es-page-copy]:not([data-es-ready])').forEach(root => {
      root.dataset.esReady = 'true';
      const kind = root.dataset.esPageCopy;
      if (kind === 'faq') {
        // Enhance the merchant's existing Q/A paragraphs; unmatched content stays intact.
        [...root.children].forEach(paragraph => {
          const question = paragraph.querySelector(':scope > strong');
          if (paragraph.tagName !== 'P' || !question || !/^Q\d+\s*:/.test(question.textContent.trim())) return;
          const details = document.createElement('details');
          details.className = 'es-faq';
          const summary = document.createElement('summary');
          const heading = document.createElement('h2');
          heading.textContent = question.textContent.trim().replace(/^Q\d+\s*:\s*/, '');
          summary.append(heading);
          const answer = document.createElement('div');
          answer.className = 'es-faq__answer';
          question.remove();
          if (paragraph.firstChild?.nodeName === 'BR') paragraph.firstChild.remove();
          if (paragraph.firstChild?.nodeType === Node.TEXT_NODE) paragraph.firstChild.textContent = paragraph.firstChild.textContent.replace(/^\s*A:\s*/, '');
          const separator = paragraph.nextElementSibling;
          if (separator?.tagName === 'HR') separator.remove();
          paragraph.replaceWith(details);
          answer.append(paragraph);
          details.append(summary, answer);
        });
      }
      if (kind === 'story') {
        const headings = new Map([
          ['🛑 The Problem', 'The problem'],
          ['✅ Our Logistics-First Solution', 'Our logistics-first solution'],
          ['⚡ Instant Quote Tool', 'Instant quote tool'],
          ['Why EverSilky?', 'Why EverSilky?']
        ]);
        [...root.children].forEach(node => {
          if (node.tagName !== 'P') return;
          const text = node.textContent.trim();
          if (!text && !node.querySelector('img,video,iframe')) { node.remove(); return; }
          if (headings.has(text)) {
            const heading = document.createElement('h2');
            heading.textContent = headings.get(text);
            node.replaceWith(heading);
          }
        });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhancePages);
  else enhancePages();
  document.addEventListener('shopify:section:load', enhancePages);
})();
